module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABJElEQVRYhe3WOwrCQBAG4D2JF8gBggeQ9CnS2tjabLmVnXdJk9bCXrAPC0IQTJaUIYMQCIGxCCJqjHnsZiz8YdvMF2Yfw9iAAAC2rSHf7JQK8tbCRjFDimvFjC0+GqMb0BtiCtAZYhrwFTIV4CNExykYjZga0AghR1ABniB/xM8gqAEAgCy0Zki92PV4oEeUSUyPYIyRtuS0mNeIyHXIEJf1qkak2w0ZIgv8GlHIkAxRQf54PyhaogR/eUX3u8kRZRK/zxTnpTcZIN1umke8MolR2pZxQOQ6z3vhNaZvUGlbWMjw+8SdBT4t4J5ChlpbE7lOP8A9FeSoBNeyCVv3QJdcjwe8rFe9iyvBm4/hmFSQYxb4qATHpuN8XnqoBMcs8Hv9+Q0CaRvuTbpJ6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/po.png
// module id = fjgq
// module chunks = 0